import { render, staticRenderFns } from "./moneyExamine.vue?vue&type=template&id=5c041f70&scoped=true&"
import script from "./moneyExamine.vue?vue&type=script&lang=js&"
export * from "./moneyExamine.vue?vue&type=script&lang=js&"
import style0 from "./moneyExamine.vue?vue&type=style&index=0&id=5c041f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c041f70",
  null
  
)

export default component.exports